import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="app-footer pt-5 pb-4">
      <div className="container">
        <div className="row gy-4">
          <div className="col-md-4">
            <h5 className="text-white mb-3">Quick Links</h5>
            <ul className="list-unstyled d-flex flex-column gap-2">
              <li>
                <Link to="/PrivacyPolicy" className="app-footer__link">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/TermsAndServices" className="app-footer__link">
                  Terms and Service
                </Link>
              </li>
              <li>
                <Link to="/Returnpolicy" className="app-footer__link">
                  Return and Refund Policy
                </Link>
              </li>
              <li>
                <Link to="/ShoppingPolicy" className="app-footer__link">
                  Shopping Policy
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-md-4">
            <h5 className="text-white mb-3">Contact</h5>
            <p className="mb-2">
              Email:{" "}
              <a href="mailto:shiva.methuku@gmail.com" className="app-footer__link">
                shiva.methuku@gmail.com
              </a>
            </p>
            <p className="mb-2">Phone: +91 630 556 5672</p>
            <p className="mb-0">
              Address: H.No:1-7-376, Revenue Colony, Subedari, Hanamkonda,
              Telangana-506001
            </p>
          </div>
          <div className="col-md-4">
            <h5 className="text-white mb-3">Follow Us</h5>
            <div className="d-flex gap-3 fs-5">
              <a href="#" className="app-footer__link" aria-label="Facebook">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="#" className="app-footer__link" aria-label="Twitter">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" className="app-footer__link" aria-label="LinkedIn">
                <i className="fab fa-linkedin"></i>
              </a>
            </div>
          </div>
        </div>
        <hr className="app-footer__divider my-4" />
        <div className="text-center">
          <p className="mb-0 app-footer__muted">
            &copy; {year} Helan Homeopathy. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
